export const tailwindConfig = {
  screens: {
    mini: { max: 390 },
    phone: { max: 640 },
    ipad: { max: 1390, min: 640 },
    laptop: { max: 1920, min: 1390 },
    desktop: { min: 1920 },
  },
};
